import { Component } from '@myriadgenetics/mgh-types';

import {
  Introductory,
  TextContent,
  OtherDiagnoses,
  TextList,
  HelpHint,
  HelpHints,
  Video,
  CriteriaDetails,
  Image,
  Cards,
  Banner,
  Accordion,
  Grid,
} from '../../components/informational';
import { OptionSelect, PersonDemographic, PersonInsurance, TextQuestion, YesNo, ImageUpload, CheckboxComponent, RadioGroup } from '../../components/question';
import ResultsButton from '../../elements/results-button';
import QualifyBanner from '../../components/informational/qualify-banner';
import TcRiskScore from '../../components/informational/tc-risk-score';
import DescriptionList from '../../components/informational/description-list';
import ContactInfo from '../../components/informational/contact-info';
import PatientName from '../../components/informational/patient-name';

const componentMap = {
  // informational
  INTRODUCTORY: Introductory,
  TEXT_CONTENT: TextContent,
  OTHER_DIAGNOSES: OtherDiagnoses,
  TEXT_LIST: TextList,
  HELP_HINT: HelpHint,
  HELP_HINTS: HelpHints,
  VIDEO: Video,
  CRITERIA_DETAILS: CriteriaDetails,
  IMAGE: Image,
  BANNER_SECTION: Banner,
  ACCORDION_SECTION: Accordion,
  GRID: Grid,
  CARDS_SECTION: Cards,
  // question
  OPTION_SELECT: OptionSelect,
  PERSON_DEMOGRAPHIC: PersonDemographic,
  IMAGE_UPLOAD: ImageUpload,
  PERSON_INSURANCE: PersonInsurance,
  TEXT_QUESTION: TextQuestion,
  YES_NO: YesNo,
  // other
  BUTTON: ResultsButton,
  CHECKBOX: CheckboxComponent,
  RADIO_GROUP: RadioGroup,
  // TODO implement in admin tool
  QUALIFY_BANNER: QualifyBanner,
  TC_RISK_SCORE: TcRiskScore,
  PATIENT_NAME: PatientName,
};

// TODO remove once telemed 40 stuff is merged
export const typeToComponent = (component: Component) => (componentMap as any)[component.type];
export const typeToComponentPilot = (component: Component) => {
  const pilotComponent = getPilotTagAndStyles(component);

  if (pilotComponent !== undefined) {
    return pilotComponent;
  }

  return [typeToComponent(component)];
};

function getPilotTagAndStyles(component: Component) {
  // TODO remove after QUALIFY_BANNER component is in admin tool
  if (
    component.type === 'TEXT_CONTENT' &&
    component.data.contentKey !== undefined &&
    /^results\.pilot\.(met|notMet)(\.\w+)?\.title$/.test(component.data.contentKey)
  ) {
    return [QualifyBanner];
  } else if (
    component.type === 'TEXT_CONTENT' &&
    component.data.contentKey !== undefined &&
    /^results\.tcComponent\.(title)$/.test(component.data.contentKey)
  ) {
    return [TcRiskScore];
  } else if (
    // TODO remove after a DESCRIPTION_LIST component is in admin tool
    component.type === 'TEXT_CONTENT' &&
    component.data.contentKey !== undefined &&
    /^results\.pilot\.(met|notMet)\.\w+\.(prequel|foresight)$/.test(component.data.contentKey)
  ) {
    return [DescriptionList];
  } else if (
    // TODO remove after a PATIENT_NAME component is in admin tool
    component.type === 'TEXT_CONTENT' &&
    component.data.contentKey !== undefined &&
    /^results\.pilot\.(met|notMet).patientName$/.test(component.data.contentKey)
  ) {
    return [PatientName];
  } else if (
    // TODO remove after a QUALIFY_BANNER component is in admin tool
    component.type === 'TEXT_CONTENT' &&
    component.data.contentKey === 'results.pilot.met.inOfficeTitle'
  ) {
    return [null];
  } else if (
    // TODO remove after a CONTACT_INFO component is in admin tool
    component.type === 'TEXT_CONTENT' &&
    component.data.contentKey === 'results.pilot.met.peContactInfo'
  ) {
    return [ContactInfo];
  } else if (component.type === 'TEXT_CONTENT' && component.data.type === 'H1') {
    return [TextContent, 'heading-large--semi-bold'];
  } else if (component.type === 'TEXT_CONTENT' && component.data.type === 'H2') {
    return [TextContent, 'heading-small--semi-bold color-gray-900'];
  } else if (component.type === 'TEXT_CONTENT' && component.data.type === 'H3') {
    return [TextContent, 'heading-small--semi-bold color-gray-900'];
  } else if (component.type === 'TEXT_CONTENT' && component.data.type === 'H4') {
    return [TextContent, 'text-large--semi-bold color-gray-600'];
  } else if (component.type === 'TEXT_CONTENT' && component.data.type === 'Text1') {
    return [TextContent, 'text-large--regular color-gray-600'];
  }

  return undefined;
}
